import type { MarketSnapshot } from "../lib/api";

interface Props {
  snapshot?: MarketSnapshot;
}

function soWhat(symbol: string, change: number): string {
  if (symbol === "VIX") {
    return change > 5 ? "vol spike — watch risk-off" : change < -5 ? "vol crush — calmer tone" : "vol steady";
  }
  if (symbol === "DXY") {
    return change > 0.2 ? "USD bid" : change < -0.2 ? "USD offered" : "USD flat";
  }
  if (["XAU", "WTI"].includes(symbol)) {
    return change > 0.5 ? `${symbol} bid` : change < -0.5 ? `${symbol} offered` : `${symbol} steady`;
  }
  return change > 0.5 ? "risk-on" : change < -0.5 ? "risk-off" : "flat";
}

export function HeadlineInstruments({ snapshot }: Props) {
  if (!snapshot?.quotes?.length) {
    return <div className="text-sm text-slate-500">Loading headline instruments…</div>;
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
      {snapshot.quotes.map((q) => {
        const up = q.change_pct >= 0;
        return (
          <div key={q.symbol} className="rounded-xl border border-surface-2 bg-surface-1 p-4">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium uppercase tracking-wider text-slate-400">{q.symbol}</span>
              {q.delayed && <span className="text-[10px] text-slate-500">delayed</span>}
            </div>
            <div className="mt-1 font-mono text-xl font-semibold">{q.price.toFixed(q.symbol === "BTC" ? 0 : 2)}</div>
            <div className={`mt-1 flex items-center gap-1 text-sm font-medium ${up ? "text-macro-up" : "text-macro-down"}`}>
              <span>{up ? "+" : ""}</span>
              <span>{q.change_pct.toFixed(2)}%</span>
            </div>
            <div className="mt-2 text-xs text-slate-400">{soWhat(q.symbol, q.change_pct)}</div>
            <div className="mt-1 text-[10px] text-slate-600">
              src: {q.source} · {new Date(q.updated_at).toLocaleTimeString()} {q.delayed && "· delayed"}
            </div>
          </div>
        );
      })}
    </div>
  );
}
